export const mobile = {
    messages: {
        zh_CN: (field) => `请输入正确的${field}！`,
    },
    validate: (value) => {
        // return value.length == 11 && /^((13[0-9])|(145)|(15[0-3])|(15[5-9])|(170)|(173)|(17[5-8])|(18[0-9])|166|198|199|(147))\d{8}$/.test(value);
        return value.length == 11 && /^1[345789]{1}[0-9]{9}$/.test(value);
    },
}
export const nickname = {
    messages: {
        zh_CN: (field) => `请检查${field}格式！`,
    },
    validate: (value) => {
        // return value.length == 11 && /^((13[0-9])|(145)|(15[0-3])|(15[5-9])|(170)|(173)|(17[5-8])|(18[0-9])|166|198|199|(147))\d{8}$/.test(value);
        return value.length > 1 && value.length < 25 && /^[\u4e00-\u9fa5_a-zA-Z0-9\-]*$/.test(value);
    },
}
export const diyMutilple = {
    messages: {
        zh_CN: (field) => `请选择${field}！`,
    },
    validate: (value) => {
        return Array.isArray(value) && value.length
    },
}
export const diySingle = {
    messages: {
        zh_CN: (field) => `请选择${field}！`,
    },
    validate: (value) => {
        // debugger
        return (!!value) && ('' + value).trim()
    },
}
export const diyImg = {
    messages: {
        zh_CN: (field) => `请上传${field}！`,
    },
    validate: (value) => {
        return !!(value.length)
    },
}


// WEBPACK FOOTER //
// ./src/utils/veeRules.js